window.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded')

  bannerOffIcon()

})

// banner 加 图标
function bannerOffIcon () {
  const bannerEl = document.querySelector('.section-range-banner-container')

  const imgIcon = document.createElement('img')
  imgIcon.src =
    'https://cdn.shopify.com/s/files/1/0582/3699/3705/files/pop4-banner-off-ks.svg?v=1776234945'
  imgIcon.alt = 'pop4-ks-icon'
  imgIcon.classList.add('pop4-ks-banner-off-icon')
  bannerEl.appendChild(imgIcon)
}

document.addEventListener('globo.formbuilder.form.submitted', e => {
  // toShowElements: ['.KSP4A__off-info-wrapper-top'],
  const cfg = {
    first: {
      sectionID: '__vbot_rich_text_EEKfjN',
      toHideElements: ['.rich-text__text.p-20-14 p', '.globo-form-app'],
    },
    second: {
      sectionID: '__vbot_rich_text_AWwedb',
      toHideElements: ['.rich-text__heading.title-48-24', '.rich-text__text'],
    }
  }
  try {
    const parent = e.detail.form.closest('[id*="__vbot_rich_text_"]')
    // console.log(`%c>> $***`, 'color:yellow', parent, parent.id)

    // 判断parent是 first 还是 second， 隐藏对应的toHideElements
    let section;
    if (parent.id.includes(cfg.first.sectionID)) {
      section = cfg.first
    } else if (parent.id.includes(cfg.second.sectionID)) {
      section = cfg.second
    }
    // console.log(`%c>> $***999`, 'color:yellow', section)
    if (section) {
      section.toHideElements.forEach(selector => {
        const el = parent.querySelectorAll(selector)
        if (el.length > 0) {
          el.forEach(item => {
            item.style.display = 'none'
          })
        }
      })

      if (section.toShowElements) {
        section.toShowElements.forEach(selector => {
          const el = parent.querySelectorAll(selector)
          if (el.length > 0) {
            el.forEach(item => {
              item.style.display = 'block'
            })
          }
        })
      }
    }
    

    if(window.location.pathname.includes('/pop4-signup-fb') && !!fbq) {
      fbq('track', 'CompleteRegistration')
    }
    // liangxing0421 
    if (location.pathname === '/pages/pop4-signup') {
      gtag_report_conversion()
      console.log('success: 注册')
    } else {
      console.log('failed：注册')
    }
  } catch (error) {
    console.log('error', error)
  }
})

// @lianging 0421
function liangxingGtmInit() {
  //   <!-- Google tag (gtag.js) -->
  const sc = document.createElement('script')
  sc.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10853964820'
  sc.async = true
  document.body.appendChild(sc)
}

// Event snippet for CF-POP4-SignUp conversion page
// In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button.
function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-10853964820/UMDTCOHZ6J8cEJS4ybco',
      'event_callback': callback
  });
  return false;
}